import { useState } from 'react'
import { Form, Button, Container, Row, Col, Spinner, Alert } from 'react-bootstrap'

import PageTitle from './PageTitle'

import emailService from '../services/EmailService'

function FormComponent() {
  const [loading, setLoading] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false)
  const [hideSendButton, setHideSendButton] = useState(false)

  const [fullName, setFullName] = useState(null)
  const [fullNameInvalid, setFullNameInvalid] = useState(false)
  const [fullNameErrorMessage, setFullNameErrorMessage] = useState('Campo obrigatório')

  const [email, setEmail] = useState(null)
  const [emailInvalid, setEmailInvalid] = useState(false)
  const [emailErrorMessage, setEmailErrorMessage] = useState('Campo obrigatório')

  const [message, setMessage] = useState(null)
  const [messageInvalid, setMessageInvalid] = useState(false)
  const [messageErrorMessage, setMessageErrorMessage] = useState('Campo obrigatório')

  const fullNameValidation = (name) => {
    if (!name || name.length === 0) {
      setFullNameErrorMessage('Campo obrigatório');
      setFullNameInvalid(true);
      setFormIsValid(false);
    } else if (name.length < 3) {
      setFullNameErrorMessage('Nome muito curto');
      setFullNameInvalid(true);
      setFormIsValid(false);
    } else if (name.length > 50) {
      setFullNameErrorMessage('Nome muito longo');
      setFullNameInvalid(true);
      setFormIsValid(false);
    } else {
      setFullNameInvalid(false);
      setFormIsValid(true);
    }
  }

  const emailValidation = (email) => {
    if (!email || email.length === 0) {
      setEmailErrorMessage('Campo obrigatório');
      setEmailInvalid(true);
      setFormIsValid(false);
    } else if (!validarEmail(email)) {
      setEmailErrorMessage('Email inválido');
      setEmailInvalid(true);
      setFormIsValid(false);
    } else {
      setEmailInvalid(false);
      setFormIsValid(true);
    }
  }

  const messageValidation = (name) => {
    if (!name || name.length === 0) {
      setMessageErrorMessage('Campo obrigatório');
      setMessageInvalid(true);
      setFormIsValid(false);
    } else if (name.length < 10) {
      setMessageErrorMessage('Mensagem muito curta');
      setMessageInvalid(true);
      setFormIsValid(false);
    } else if (name.length > 300) {
      setMessageErrorMessage('Mensagem muito longa');
      setMessageInvalid(true);
      setFormIsValid(false);
    } else {
      setMessageInvalid(false);
      setFormIsValid(true);
    }
  }

  const validarEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const handleSubmit = async (event) => {
    try {
      event.preventDefault();

      const emptyFields = [];

      const form = event.currentTarget;
      const formElements = Array.from(form.elements);
      formElements.forEach((element) => {
        if (
          element.tagName === 'INPUT' ||
          element.tagName === 'SELECT' ||
          element.tagName === 'TEXTAREA'
        ) {
          if (element.hasAttribute('required') && !element.value.trim()) {
            emptyFields.push(element.name || element.id || '[campo sem nome]');
            if (element.name === 'fullName') {
              setFullNameInvalid(true);
              setFullNameErrorMessage('Campo obrigatório');
            }
            if (element.name === 'email') {
              setEmailInvalid(true);
              setEmailErrorMessage('Campo obrigatório');
            }
            if (element.name === 'message') { 
              setMessageInvalid(true);
              setMessageErrorMessage('Campo obrigatório');
            }
          }
        }
      });

      if (form.checkValidity() === false) {
        event.stopPropagation();
      } else {
        if (!formIsValid) {
          console.log('Formulário inválido');
          return;
        } else {
          setLoading(true);
          const params = {
            'fromName': '[Site] Agência BlackStar',
            'fromEmail': 'contato@nois.dev.br',
            'toName': 'Agência BlackStar',
            'toEmail': 'blackstardesign@hotmail.com',
            'subject': 'Mensagem enviada pelo formulário do site',
            'text':  `Nome: ${fullName} \nE-mail: ${email}\nMensagem: ${message}`
          };
          // Enviar email 
          const response = await emailService.sendMail(params, fullName, email);
          console.log('Response:', response)
          // Redirecionar para pagina de pagamento
          setTimeout(() => {
            setLoading(false);
            setHideSendButton(true);
          }, 3000);
        }
      }
    } catch (error) {
      console.error('Erro ao enviar o formulário:', error);
      setLoading(false);
    }
  }

  return (
    <Container style={{ color: '#FFF' }}>
      <PageTitle className="cloister-black" size="60" title="Contato" />
      <Row className="justify-content-md-center align-items-center">
        <Col md={6} className="d-flex align-items-center justify-content-center">
          <Row>
            <Col className='text-center' style={{ fontSize: '18px' }} xs={12} sm={12} md={12} lg={12}>
              <Row style={{ padding: '20px' }}>
                <Col>
                  <span style={{ fontSize: '22px', fontWeight: '700' }}>
                    VAMOS TOMAR UM CAFÉ?
                  </span>
                </Col>
              </Row>
              <Row style={{ padding: '20px' }}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <span>
                    Rua Hermínio Pinto, 4-25
                  </span>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <span>
                    Higienópolis - Bauru/SP
                  </span>
                </Col>
              </Row>
              <Row style={{ padding: '20px' }}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <span>
                    E-mail:
                  </span>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <span>
                    blackstardesign@hotmail.com
                  </span>
                </Col>
              </Row>
              <Row style={{ padding: '20px' }}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <span>
                    Telefone:
                  </span>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <span>
                    (14) 99796-5327
                  </span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col md={6}>
          <Form noValidate onSubmit={handleSubmit} className='form-contact'>
            <Row>
              <Col xs={12} sm={12} md={12} lg={10}>
                <Form.Group controlId="formName" style={{marginBottom: '10px' }}>
                  <Form.Control
                    required
                    name="fullName"
                    type="text"
                    placeholder="NOME"
                    onChange={e => setFullName(e.target.value)}
                    onBlur={() => fullNameValidation(fullName)}
                    isInvalid={fullNameInvalid}
                    className='form-default'
                  />
                  <Form.Control.Feedback type="invalid">
                    {fullNameErrorMessage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={10}>
                <Form.Group controlId="formEmail" style={{marginBottom: '10px' }}>
                  <Form.Control
                    required
                    name="email"
                    type="email"
                    placeholder="E-MAIL"
                    onChange={e => setEmail(e.target.value)}
                    onBlur={() => emailValidation(email)}
                    isInvalid={emailInvalid}
                    className='form-default'
                  />
                  <Form.Control.Feedback type="invalid">
                    {emailErrorMessage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={10}>
                <Form.Group controlId="formMessage">
                  <Form.Control
                    required
                    name="message"
                    as="textarea"
                    rows={4}
                    placeholder="MENSAGEM"
                    onChange={e => setMessage(e.target.value)}
                    onBlur={() => messageValidation(message)}
                    isInvalid={messageInvalid}
                    className='form-default'
                  />
                  <Form.Control.Feedback type="invalid">
                    {messageErrorMessage}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={12} md={12} lg={10} style={{ marginTop: '10px' }}>
                <Button type="submit" disabled={loading} className="btn btn-success button-primary-color">
                  {loading ? (
                    <>
                      <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                      {' '}ENVIANDO...
                    </>
                  ) : (
                    'ENVIAR'
                  )}
                </Button>
              </Col>
              <Col xs={12} sm={12} md={12} lg={10} style={{ marginTop: '10px' }}>
                <Alert hidden={!hideSendButton} variant="success" className='text-center'>
                  <p className="mb-0">
                    Mensagem enviada com sucesso! Em breve entraremos em contato.
                  </p>
                </Alert>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </Container>
  )
}

export default FormComponent